export const environment = {
    production: false,
    url: "https://api-tune.policystreet.app/api",
};
